import React from 'react'
import { connect } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { AuthUserSelection } from './AuthUserSelection'
import { withOktaAuth } from '@okta/okta-react'
import { IOktaContext } from '@okta/okta-react/bundles/types/OktaContext'
import { configurationStoreSelector, connectionStoreSelector } from 'selectors/storeSelectors'
import { ConnectionActions } from 'store/connection'

export interface AuthCredentialsRetrievalProps extends IOktaContext {
  authenticationEnabled: boolean
  lastErrorMessage: string | null
  lastSocketErrorMessage: string | null
  onSetCredentials: (username: string) => unknown
  signOut(errorMessage: string | null): unknown
}

const mapStateToProps = createSelector(configurationStoreSelector, connectionStoreSelector, (configuration, connectionStore) => {
  return {
    authenticationEnabled: configuration.authentication ? configuration.authentication.enabled : false,
    lastErrorMessage: connectionStore.lastErrorMessage,
    lastSocketErrorMessage: connectionStore.lastSocketErrorMessage
  }
})

const mapDispatchToProps = {
  onSetCredentials: ConnectionActions.setCredentials,
  signOut: ConnectionActions.signOut
}

class AuthCredentialsRetrievalComponent extends React.Component<AuthCredentialsRetrievalProps> {
  async componentDidMount() {
    const { authState, authenticationEnabled, lastErrorMessage, lastSocketErrorMessage, onSetCredentials, signOut } = this.props

    if (!authenticationEnabled) {
      return
    }

    if (!authState) {
      throw new Error('Unable to retrieve auth utility from context in Login component')
    }

    const authenticated = authState.isAuthenticated
    if (authenticated) {
      const token = authState.accessToken?.accessToken
      if (token && !lastErrorMessage && !lastSocketErrorMessage) {
        onSetCredentials(token)
      } else {
        signOut(lastSocketErrorMessage || lastErrorMessage)
      }
    }
  }

  render() {
    const { authenticationEnabled } = this.props
    return !authenticationEnabled ? <AuthUserSelection /> : null
  }
}

export const AuthCredentialsRetrieval = connect(mapStateToProps, mapDispatchToProps)(withOktaAuth(AuthCredentialsRetrievalComponent))
